import { appendCheckboxesToFormData } from "@rootreeweb/js-lib";

import { extractProductDetails } from "./details";
import { createEmailPayload } from "./textFormatter";

const includedFields = [
	"FirstName",
	"LastName",
	"Company",
	"Email",
	"Phone",
	"languagepref",
	"productInfoRequest",
	"Consent Text",
	"Consent Time",
] as const;

export type ProductFormRequest = {
	[key in IncludedField]: string;
};
type IncludedField = (typeof includedFields)[number];

/**
 * Bundles the request for being sent to the server.
 *
 * @param contactForm The form to package.
 * @returns The request as a JSON string.
 */
export function packageRequest(
	contactForm: HTMLFormElement,
): ProductFormRequest {
	const data = new FormData(contactForm);
	appendCheckboxesToFormData(contactForm, data);
	const details = extractProductDetails(data);
	data.append("productInfoRequest", createEmailPayload(details));
	const filtered = filterFormData(data);
	return Object.fromEntries(
		Array.from(filtered).filter((x) => typeof x[1] === "string"),
	) as ProductFormRequest;
}

/**
 * Filters the form data to only include the fields that should be sent to the
 * server.
 *
 * @param data The form data to filter.
 * @returns The filtered form data.
 */
function filterFormData(data: FormData): FormData {
	const filtered = new FormData();
	for (const [key, value] of Array.from(data.entries())) {
		if (isIncludedField(key)) {
			filtered.append(key, value);
		}
	}
	return filtered;
}

/**
 * Determines if a key is an included field.
 *
 * @param key The key to check.
 * @returns True if the key is an included field.
 */
function isIncludedField(key: string): key is IncludedField {
	return includedFields.includes(key as IncludedField);
}
